import { Dispatch, FC, SetStateAction, useEffect } from "react";
import { Control, FieldValues } from "react-hook-form";
import SearchTable from "../../../components/template/Search/SearchTable";
import ModalIndicator from "../component/ModalIndicator";
import { TableConfig } from "../../../types/Components/Table/TableConfig";
import { FilterConfig } from "../../../types/Components/Table/FilterConfig";
import { PaginationConfig } from "../../../types/Components/Table/PaginationConfig";
import { ModalConfig } from "../../../types/Components/Modal/ModalConfig";
import { IndicatorFormValues } from "../../../types/Indicator/IndicatorDataReport/IndicatorFormValues";

interface IndicatorSearchTableProps {
  searchTableName: string;
  tableConfig: TableConfig;
  filterConfig: FilterConfig;
  paginationConfig: PaginationConfig;
  modalConfig: ModalConfig;
  control: Control<FieldValues, any>;
  setIsSearching: Dispatch<SetStateAction<boolean>>;
  setFormValues: Dispatch<SetStateAction<IndicatorFormValues>>;
  formValues: IndicatorFormValues;
}

const IndicatorSearchTable: FC<IndicatorSearchTableProps> = ({
  searchTableName,
  tableConfig,
  filterConfig,
  paginationConfig,
  modalConfig,
  control,
  setIsSearching,
  setFormValues,
  formValues,
}) => {
  useEffect(() => {
    const row = control._formValues?.row;
    if (row) {
      setFormValues({
        frequency: row.frequency || null,
        province: row.province || null,
        county: row.county || null,
        indicator: row.indicator || null,
      });
    }
  }, [control._formValues?.row, setFormValues]);

  return (
    <>
      <SearchTable
        showModal
        searchTableName={searchTableName}
        accordionTitle="Filtrar"
        headingFontSize="2xl"
        tableConfig={tableConfig}
        filterConfig={filterConfig}
        paginationConfig={paginationConfig}
        setIsSearching={setIsSearching}
      />
      <ModalIndicator
        control={control}
        modalConfig={modalConfig}
        indicatorId={filterConfig.filters[0].value ?? ""}
        frequency={formValues.frequency ?? null}
        provinceId={formValues.province?.id ?? undefined}
        countyId={formValues.county?.id ?? undefined}
        historyTitle={formValues.province?.name ?? ""}
      />
    </>
  );
};

export default IndicatorSearchTable;
